import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section aria-labelledby="faq" className="bg-ink-900" data-id="element-52" data-mp="1blaij6txinsu">
      <div className="mx-auto max-w-3xl px-5 py-16 sm:py-20" style={{
      paddingTop: "12px",
      paddingBottom: "21px"
    }} data-id="element-53" data-mp="1bmven0vw6est">
        <h2 id="faq" className="text-center font-display text-2xl uppercase text-white sm:text-3xl" style={{
        color: "#4B7BFF"
      }} data-id="element-54" data-mp="248oa0peuyr5k">
          Lo que más nos preguntan
        </h2>

        <ul className="mt-8 space-y-3" data-id="element-55" data-mp="1ujehx9k0l8hg">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} className="overflow-hidden rounded-2xl border border-ink-600 bg-ink-800" data-id="element-56" data-mp="1zhfwpiaeqln4" data-mpi={index}>
                <h3 data-id="element-57" data-mp="2n7aac22jwe8f">
                  <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} aria-controls={`faq-panel-${index}`} className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left text-[15px] font-semibold text-white transition-colors duration-150 ease-out hover:text-ball-400 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-ball-400/60" data-id="element-58" data-mp="2n6r2je6m7684">
                    {faq.question}
                    <ChevronDownIcon className={`h-5 w-5 shrink-0 text-ball-400 transition-transform duration-200 ease-out ${isOpen ? 'rotate-180' : ''}`} aria-hidden="true" data-id="element-59" data-mp="19tc2b3sefynv" />
                  </button>
                </h3>
                {isOpen && <div id={`faq-panel-${index}`} className="px-5 pb-5" data-id="element-60" data-mp="1jmat8sbdc1an">
                    <p className="text-sm leading-relaxed text-slate-400" data-id="element-61" data-mp="1xioco6zgqcrr">{faq.answer}</p>
                  </div>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}